import Axios from 'axios';
import { ComplaintAPI } from '../scenes/complaint/complaint-api.type';

export const listComplaintsRequest = async (filters?: ComplaintAPI.ComplaintFilters) => {
  const { data } = await Axios.post<ComplaintAPI.ListComplaintsResponse>(
    `${window.API_ENDPOINT}/ComplaintHandlers/list`,
    filters
  );
  return data;
};
